import { useEffect, useState } from "react";
import { storefront } from "@/helpers/store";
export function useWholesalePage() {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const query = `
          query GetCareersPage {
            pageByHandle(handle: "wholesale-sloth-gifts") {
              id
              title
              handle
              body
              createdAt
              updatedAt
            }
          }
        `;

        const response = await storefront(query);
        const { pageByHandle } = response.data;

        setPage(pageByHandle);
        setLoading(false);
      } catch (error) {
        console.error("Error:", error);
        setLoading(false);
      }
    };

    fetchPage();
  }, []);

  return { page, loading };
}

export function useCareersPage() {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const query = `
          query GetCareersPage {
            pageByHandle(handle: "careers") {
              id
              title
              handle
              body
              createdAt
              updatedAt
            }
          }
        `;

        const response = await storefront(query);
        const { pageByHandle } = response.data;

        setPage(pageByHandle);
        setLoading(false);
      } catch (error) {
        console.error("Error:", error);
        setLoading(false);
      }
    };

    fetchPage();
  }, []);

  return { page, loading };
}

export function useTOSPage() {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const query = `
          query GetTOSPage {
            pageByHandle(handle: "terms-of-service-returns-policy") {
              id
              title
              handle
              body
              createdAt
              updatedAt
            }
          }
        `;

        const response = await storefront(query);
        const { pageByHandle } = response.data;

        setPage(pageByHandle);
        setLoading(false);
      } catch (error) {
        console.error("Error:", error);
        setLoading(false);
      }
    };

    fetchPage();
  }, []);

  return { page, loading };
}
